export const MIN_WIDTH = 400;
